<template>
  <span ref="anchorRef" class="confetti-anchor" aria-hidden="true"></span>
</template>

<style lang="scss" scoped>
// an invisible marker at the score's centre; confetti bursts from here
.confetti-anchor {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
}
</style>

<script setup lang="ts">
import { ref, watch } from 'vue'
import confetti from 'canvas-confetti'

// bursts confetti from this element each time `trigger` increases
const props = defineProps<{ trigger: number; color?: string }>()

const anchorRef = ref<HTMLElement>()
const palette = ['#f7810a', '#ffd400', '#39b54a', '#2e9bd6', '#e23b6d', '#8e5ad6']

watch(() => props.trigger, (value, previous) => {
  if (value <= previous || !anchorRef.value) {
    return // only celebrate when the score goes up
  }
  const rect = anchorRef.value.getBoundingClientRect()
  confetti({
    particleCount: 90,
    spread: 80,
    startVelocity: 38,
    origin: { x: rect.left / window.innerWidth, y: rect.top / window.innerHeight },
    colors: props.color ? [props.color, ...palette] : palette,
  })
})
</script>
